<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-lg-8">

      <h1 class="display-6 fw-bold mb-2">Terms of Service</h1>
      <p class="text-body-secondary mb-4">Last updated: February 2026</p>
      <hr>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">1. Acceptance of Terms</h2>
        <p>By accessing or using Vocabulary ("the Service"), you agree to be bound by these Terms of Service and our <a routerLink="/privacy">Privacy Policy</a>. If you do not agree to these terms, please do not use the Service.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">2. Description of Service</h2>
        <p>Vocabulary is a web-based application that helps users learn and manage vocabulary across multiple languages. The Service allows you to create, organise, and review vocabulary entries.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">3. User Accounts and Authentication</h2>
        <p>To use the Service, you must create an account. Authentication is managed through Keycloak, our identity provider. You are responsible for:</p>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">Maintaining the confidentiality of your account credentials.</li>
          <li class="list-group-item">All activities that occur under your account.</li>
          <li class="list-group-item">Notifying us immediately of any unauthorised use of your account.</li>
        </ul>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">4. User Content</h2>
        <p>You retain ownership of any vocabulary entries and content you create within the Service. By using the Service, you grant us a limited licence to store and process your content solely for the purpose of providing the Service to you.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">5. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for any unlawful purpose.</li>
          <li>Attempt to gain unauthorised access to the Service, its systems, or other users' accounts.</li>
          <li>Interfere with or disrupt the integrity or performance of the Service.</li>
          <li>Upload malicious content or engage in abusive behaviour.</li>
          <li>Circumvent any security measures, including authentication mechanisms.</li>
        </ul>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">6. Logging and Monitoring</h2>
        <div class="alert alert-secondary">
          For security and operational purposes, the Service logs IP addresses and user activity. This data is used to detect and prevent unauthorised access, investigate security incidents, and ensure the stability of the Service. For more details, see our <a routerLink="/privacy" class="alert-link">Privacy Policy</a>.
        </div>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">7. Security</h2>
        <p>All communication with the Service is encrypted via HTTPS. We implement appropriate technical measures to protect the Service and your data, but no system is completely secure. You acknowledge that you use the Service at your own risk.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">8. Availability</h2>
        <p>We strive to keep the Service available but do not guarantee uninterrupted access. We may suspend or modify the Service at any time for maintenance, updates, or other reasons without prior notice.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">9. Limitation of Liability</h2>
        <p>The Service is provided "as is" without warranties of any kind, express or implied. To the fullest extent permitted by applicable law, we shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">10. Termination</h2>
        <p>We reserve the right to suspend or terminate your account if you violate these terms. You may @if (auth.isAuthenticated()) {<a routerLink="/settings/delete-user">delete your account</a>} @else {delete your account} at any time. Upon deletion, your data will be removed in accordance with our <a routerLink="/privacy">Privacy Policy</a>.</p>
      </section>

      <section class="mb-4">
        <h2 class="h5 fw-semibold">11. Changes to Terms</h2>
        <p>We may update these terms from time to time. Changes will be posted on this page. Continued use of the Service after changes constitutes acceptance of the revised terms.</p>
      </section>

      <section>
        <h2 class="h5 fw-semibold">12. Governing Law</h2>
        <p>These terms are governed by and construed in accordance with the laws of Switzerland. Any disputes shall be subject to the exclusive jurisdiction of the courts of Switzerland.</p>
      </section>

    </div>
  </div>
</div>
